export default [
    {
        value: "SemVinculo",
        text: "Sem vínculo"
    },
    {
        value: "AssinaturaDoContrato",
        text: "Assinatura do contrato"
    },
    {
        value: "RelatorioFinanceiro",
        text: "Relatório financeiro"
    },
    {
        value: "RelatorioTecnico",
        text: "Relatório técnico"
    },
    {
        value: "RelatorioMensal",
        text: "Relatório mensal"
    },
    {
        value: "RelatorioAtividades",
        text: "Relatório de atividades"
    },
    {
        value: "RelatorioDeEtapas",
        text: "Relatório de etapas"
    },
    {
        value: "RelatorioFinal",
        text: "Relatório final"
    },
]